import React from 'react';
import { useParams } from 'react-router-dom';

const Error = () => {
    
    return (
        <div>
            <h3 className='text-center mt-5 text-warning'>this page  is not available</h3>
        </div>
    );
};

export default Error;